import React from 'react'
import { useDispatch } from 'react-redux'
import { login } from 'packages/authentication/lib/actions'
import SectionType from 'models/types/ts/sectionType'
import { Container, Button } from 'layouts'
import { HeadingMedium, HeadingSmall, ParagraphLarge } from 'layouts/typography'
import { FeatureVideo } from 'features'
import getConfig from 'config/web'
import style from '../../RecruitMain.module.scss'

interface Props {
    section: SectionType
    loggedIn: boolean
}

const { authentication } = getConfig()

const Hero = ({ section, loggedIn }: Props): JSX.Element => {
    const dispatch = useDispatch()

    return (
        <div className={style.wrap}>
            <Container>
                <div className={style.introWrapper}>
                    <div>
                        <div className={style.intro}>
                            <HeadingMedium>{section.headline}</HeadingMedium>
                            <HeadingSmall as="h2">
                                {section.teaser}
                            </HeadingSmall>
                            {!loggedIn && (
                                <>
                                    <ParagraphLarge>
                                        {section.body}
                                    </ParagraphLarge>
                                    <Button
                                        onClick={() =>
                                            dispatch(
                                                login(
                                                    '/recruit',
                                                    authentication
                                                )
                                            )
                                        }
                                        internal={false}
                                        size="small"
                                        data-id="recruitLogInBtn"
                                        className={style.recruitLogin}
                                        theme="recruit"
                                    >
                                        {section.buttonText}
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>
                    {!loggedIn && (
                        <div className={style.recruitVideo}>
                            <FeatureVideo
                                image="https://web.ccpgamescdn.com/aws/eveonline/images/misc/recruit-thumb.jpg"
                                videoId="YMXelBrkyTQ"
                                subTitle=""
                            />
                        </div>
                    )}
                </div>
            </Container>
        </div>
    )
}

export default Hero
